import { render, staticRenderFns } from "./viewWeek.vue?vue&type=template&id=2d8a804c&scoped=true&"
import script from "./viewWeek.vue?vue&type=script&lang=js&"
export * from "./viewWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a804c",
  null
  
)

export default component.exports